import { createSlice } from '@reduxjs/toolkit';
import {
  wcaGetCallSettings,
  wcaSetCallSettings,
  wcaGetWhatsappProfile,
  wcaSetWhatsappProfile,
  wcaUploadProfilePicture,
} from './setting.action';

const INITIAL_STATE = {
  loading: false,
  callSettings: {},
  whatsappProfile: {},
  error: null,
};

const wcaSettingSlice = createSlice({
  name: 'wca_settings',
  initialState: INITIAL_STATE,
  reducers: {
    resetWcaSettingsState(state) {
      state.callSettings = {};
      state.whatsappProfile = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    /* ================= CALL SETTINGS ================= */

    builder.addCase(wcaGetCallSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(wcaGetCallSettings.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.callSettings = payload?.data || payload;
    });
    builder.addCase(wcaGetCallSettings.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(wcaSetCallSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(wcaSetCallSettings.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.callSettings = payload?.data || payload;
    });
    builder.addCase(wcaSetCallSettings.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    /* ================= WHATSAPP PROFILE ================= */

    builder.addCase(wcaGetWhatsappProfile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(wcaGetWhatsappProfile.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.whatsappProfile = payload?.data || payload;
    });
    builder.addCase(wcaGetWhatsappProfile.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(wcaSetWhatsappProfile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(wcaSetWhatsappProfile.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.whatsappProfile = payload?.data || payload;
    });
    builder.addCase(wcaSetWhatsappProfile.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(wcaUploadProfilePicture.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(wcaUploadProfilePicture.fulfilled, (state) => {
      state.loading = false;
    });

    builder.addCase(wcaUploadProfilePicture.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
});

export const { resetWcaSettingsState } = wcaSettingSlice.actions;

export default wcaSettingSlice.reducer;
